import { useNavigate, useParams } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import FamousShipmentModal from './components/FamousShipmentModal';
import useFamousShipment from 'src/api/temp/famous/useFamousShipment';
import { Card, CircularProgress } from '@mui/material';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import ErrorMessage from 'src/components/errorMessage/ErrorMessage';

export function Route() {
  const { shipmentId } = useParams({
    from: '/authenticated/famous-edi-shipments/$shipmentId',
  });
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: shipment, isLoading, error } = useFamousShipment(shipmentId);

  const handleClose = (shouldRefetch?: boolean) => {
    if (shouldRefetch) {
      queryClient.invalidateQueries({ queryKey: ['famous/shipments'] });
    }
    navigate({
      to: '..',
      viewTransition: true,
    });
  };

  // Show loading state while fetching
  if (isLoading) {
    return (
      <Card sx={{ p: 2, m: 2 }}>
        <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress size={24} sx={{ mr: 2 }} />
          <MDTypography variant="body2">Loading shipment...</MDTypography>
        </MDBox>
      </Card>
    );
  }

  // Show error state
  if (error) {
    return (
      <Card sx={{ p: 2, m: 2 }}>
        <ErrorMessage error={error} />
      </Card>
    );
  }

  // Show modal only when data is loaded
  if (!shipment) {
    return null;
  }

  return (
    <FamousShipmentModal famousShipment={shipment} onClose={handleClose} />
  );
}
